const s3helper = {
    region: window.s3.region,
    bucket: window.s3.bucket,
    brandingId: window.s3.brandingId,
    cloudfrontPath: window.s3.cloudfrontPath,

    enforceCDN: function (url) {
        if (s3helper.isValidS3Url(url)) {
            return s3helper.getSpeedyURL(url);
        }
        return s3helper.getSpeedyURLByAssetPath(url);
    },
    getSpeedyURL: function (url) {
        const urlInfo = s3helper.parseS3UrlOrFail(url)
        const match = urlInfo.key.match(/^public\/(.*)/i)
        if (!match) {
            return url
        }
        return s3helper.cloudfrontPath + '/' + match[1]
    },

    getSpeedyURLByAssetPath: function (assetPath) {
        if (!assetPath.length) {
            return '';
        }
        if (assetPath.indexOf('/') !== 0) {
            assetPath = '/' + assetPath;
        }
        return s3helper.cloudfrontPath + assetPath;
    },

    isValidS3Url: function (url) {
        if (!url.length) {
            return false;
        }
        try {
            s3helper.parseS3UrlOrFail(url);
        } catch (e) {
            return false;
        }

        return true;
    },

    parseS3UrlOrFail: function (url)
    {
        const s3Info = s3helper.parseS3Url(url);

        // We may receive legacy S3 url containing old region and bucket...
        // Those files are moved to new (current) region and bucket, so we use these instead
        // on bucket and region defined on S3 url
        if (s3helper.brandingId === 6014) {
            if (s3Info['region'] === 'eu-central-1' && s3Info['bucket'] === 'tsp.no') {
                s3Info['region'] = s3helper.region;
                s3Info['bucket'] = s3helper.bucket;
            }
        }

        if (s3Info['region'] !== s3helper.region) {
            throw new Error("S3 url contains a forbidden region: " + s3Info['region']);
        }
        if (s3Info['bucket'] !== s3helper.bucket) {
            throw new Error("S3 url contains a forbidden bucket: " + s3Info['bucket']);
        }

        return s3Info;
    },
    parseS3Url: function (url)
    {
        const urlNoParams = url.trim().split('?')[0]

        if (!urlNoParams.length) {
            throw new Error('parseS3Url requires an S3 url. Url was empty.')
        }

        const regexMatch = /.*s3\.(?<region>[\w.-]+)\.amazonaws\.com\/(?<bucket>[\w.-]+)\/(?<key>.*)/i
        const match = urlNoParams.match(regexMatch)

        if (!match || !match.groups || !match.groups.region || !match.groups.bucket || !match.groups.key) {
            throw new Error('parseS3Url requires an S3 url.')
        }

        return match.groups
    }
}

export default s3helper